<template>
  <div class="login-to-olb-grid">
    <div class="login-to-olb-text">
      <p>
        <a class="log-in"  target="_blank"
                    href="https://banking.commercebank.com/CBI/Auth/login">Log in </a>or <a class="log-in"  target="_blank"
          href="https://banking.commercebank.com/CBI/RetailEnrollment.aspx">activate</a> Commerce Bank Online Banking to perform other account management activities.
      </p>
    </div>
    
  </div>
</template>

<script>
import PrimaryButton from "@Shared/components/PrimaryButton.vue";
export default {
  name: "LoginToOnlineBanking",
  components: {
    PrimaryButton,
  },

};
</script>

<style lang="scss" scoped>
.login-to-olb-grid {
  display: grid;
  grid-template-rows: repeat(2, auto);
  row-gap: 20px;

  @media all and (max-width: $grid-breakpoint-md) {
    grid-template-columns: 1fr;
    row-gap: 5%;
    margin: 0;
  }

  .login-to-olb-text {
    margin-bottom: 15px;
  }
}

.text-and-btn {
  @media all and (max-width: $grid-breakpoint-sm) {
    text-align: center;
  }

  .olb-btn {
    @media all and (max-width: $grid-breakpoint-sm) {
      width: 100%;
      margin-bottom: 15px;
      padding: 10px;
      border-radius: 5px;
    }
  }
}

.log-in{
  color:  #007AA3;
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  text-decoration-line: underline;
}

.activate-olb {
  font-size: 14px;
  font-weight: 700;
  padding: 0px 20px;
  text-decoration: none;
  transition: text-decoration 300ms linear;
  color: #007aa3;

  &:hover {
    text-decoration: underline;
  }
}
</style>
